import actionTypes from "constants/map";
import { RegionDryingPeriod } from "helpers/models";
import { Action, ActionFunctionAny, createActions } from "redux-actions";
import { getPoints as platonPoints } from "sources/books/platonPoints";
import { getPostamatPointsList } from "sources/books/postamatPoints";
import {
    getLastCarsLocations,
    getPaymentPointsList,
    getRoadRestrictionsList,
    getRoadRestrictionTypesForFilterList,
} from "sources/map";

const {
    SWITCH_MAP,
    MERGE_MAP_VIEWPORT,
    MERGE_MAP_DATA,
    MERGE_PARAMS,
    CHANGE_CENTER,
    MERGE_MAP_HEADER,
    GET_PLATON_POINTS,
    GET_POSTAMAT_POINTS,
    GET_PAYMENT_POINTS,
    GET_ROAD_RESTRICTIONS,
    GET_ROAD_RESTRICTION_TYPES,
    SET_REGION_DRYING_PERIODS,
} = actionTypes;

const actions = createActions(
    SWITCH_MAP,
    MERGE_MAP_VIEWPORT,
    MERGE_MAP_DATA,
    MERGE_PARAMS,
    CHANGE_CENTER,
    MERGE_MAP_HEADER,
    GET_PLATON_POINTS,
    GET_POSTAMAT_POINTS,
    GET_PAYMENT_POINTS,
    GET_ROAD_RESTRICTIONS,
    GET_ROAD_RESTRICTION_TYPES,
    SET_REGION_DRYING_PERIODS,
);

const switchMap = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.switchMap(params));

const mergeMapViewport = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.mergeMapViewport(params));

const mergeMapData = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.mergeMapData(params));

const mergeMapHeader = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.mergeMapHeader(params));

const changeCenter = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.changeCenter(params));

const mergeParams = (params: { trailerTypeIds?: number[] }) => (dispatch: ActionFunctionAny<Action<Object>>) => {
    const carsLastLocationsRequestSentAt = Date.now();
    dispatch(actions.mergeMapData({ isLoading: true, carsLoadedAt: null, items: [], carsLastLocationsRequestSentAt }));
    dispatch(actions.mergeParams(params));
    return getLastCarsLocations(params).then((data) =>
        dispatch(
            actions.mergeMapData({
                isLoading: false,
                carsLoadedAt: Date.now(),
                items: data || [],
                carsLastLocationsRequestSentAt,
            }),
        ),
    );
};

const getPlatonPoints = () => (dispatch: ActionFunctionAny<Action<Object>>) =>
    platonPoints().then((data) => dispatch(actions.getPlatonPoints(data)));

const getPostamatPoints = () => (dispatch: ActionFunctionAny<Action<Object>>) =>
    getPostamatPointsList().then((data) => dispatch(actions.getPostamatPoints(data)));

const getPaymentPoints = () => (dispatch: ActionFunctionAny<Action<Object>>) =>
    getPaymentPointsList().then((data) => dispatch(actions.getPaymentPoints(data)));

const getRoadRestrictions = () => (dispatch: ActionFunctionAny<Action<Object>>) =>
    getRoadRestrictionsList().then((data) => dispatch(actions.getRoadRestrictions(data || [])));

const getRoadRestrictionTypes = () => (dispatch: ActionFunctionAny<Action<Object>>) =>
    getRoadRestrictionTypesForFilterList().then((data) => dispatch(actions.getRoadRestrictionTypes(data || [])));

const setRegionDryingPeriods = (data: RegionDryingPeriod[]) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.setRegionDryingPeriods(data || []));

export default {
    ...actions,
    switchMap,
    mergeMapViewport,
    mergeMapData,
    mergeParams,
    changeCenter,
    mergeMapHeader,
    getPlatonPoints,
    getPostamatPoints,
    getPaymentPoints,
    getRoadRestrictions,
    getRoadRestrictionTypes,
    setRegionDryingPeriods,
};
